import { render, staticRenderFns } from "./PriceCardView.vue?vue&type=template&id=6520dedc&scoped=true"
import script from "./PriceCardView.vue?vue&type=script&lang=ts"
export * from "./PriceCardView.vue?vue&type=script&lang=ts"
import style0 from "./PriceCardView.vue?vue&type=style&index=0&id=6520dedc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520dedc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6520dedc')) {
      api.createRecord('6520dedc', component.options)
    } else {
      api.reload('6520dedc', component.options)
    }
    module.hot.accept("./PriceCardView.vue?vue&type=template&id=6520dedc&scoped=true", function () {
      api.rerender('6520dedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/prices/PriceCardView.vue"
export default component.exports